export { FilterFacetsContent } from './FilterFacetsContent';
